import { handleResponse, handleError } from './api-utils';
import { apiConstants } from './api-constants';

export function getSSOForgotPasswordFormData() {
    return fetch(apiConstants.loadForgotPasswordFormDataUrl)
        .then(handleResponse)
        .catch(handleError);
}


export function handleUserForgotPassword(userForgotPasswordData, callbackUrl) {
    return fetch(callbackUrl, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify(userForgotPasswordData)
    })
        .then(handleResponse)
        .catch(handleError);
}
